import { FormInputBlock } from './form-input-block.js'
import type { EventType, HtmlType, NameAndType } from '../../types.js'
import type { TsCodeType } from '../../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { LeafBlock } from '../leaf-block.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { Expression } from '../../data/text-or-code.js'
import { TextOrExpression_assumeExpression } from '../../data/text-or-code.js'
import { Parameter } from '../../script/parameter.js'
import { BlockBindingType } from '../block.js'

@jsonClass('CheckboxBlock')
export class CheckboxBlock extends FormInputBlock {
	@jsonProperty(TextOrExpression_assumeExpression)
	@ScreenEditorInput<CheckboxBlock>({
		inputType: 'code',
		order: 1,
		label: 'Text next to checkbox',
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
	})
	textCode = new TextOrExpression_assumeExpression('', 'T')

	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'dropdown',
		order: 2,
		label: 'Binding type',
		options: Object.entries(BlockBindingType),
	})
	bindingType: BlockBindingType = 'binding'

	@jsonProperty(Expression)
	@ScreenEditorInput<CheckboxBlock>({
		inputType: 'code',
		order: 3,
		label: (blocks) =>
			blocks[0].bindingType == 'binding' ? 'Binding' : 'Binding getter',
		codeLanguage: 'ts',
		tsReturnType: () => 'boolean',
		editorSize: 'singleline',
		isBinding: true,
		isMandatory: () => true,
	})
	bindingCode = new Expression()

	@jsonProperty(TextOrExpression_assumeExpression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 5,
		label: 'Label',
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
	})
	labelCode = new TextOrExpression_assumeExpression('', 'T')

	canAcceptVariableString = (variable: NameAndType) => true
	acceptVariableString = (variable: NameAndType) => {
		if (variable.type == 'boolean') {
			this.bindingCode = new Expression(variable.name)
		} else {
			this.labelCode = new TextOrExpression_assumeExpression(variable.name, 'E')
		}
	}

	constructor(init: Partial<CheckboxBlock> = {}) {
		super()
		this.init(init)
	}

	get allowedEventTypes(): EventType[] {
		return [
			{
				name: 'change',
				parameters: [
					new Parameter({
						name: 'isChecked',
						type: 'boolean',
						defaultExpression: '$event.checked',
					}),
				],
			},
		]
	}

	producePreview(): HtmlType {
		return `<input type="checkbox" tabindex="-1">${this.calculateExampleText()}`
	}

	getEditorCategory(): string {
		return 'Core'
	}

	getValidationValueType(): string {
		return 'boolean'
	}
}
